export const EVENT_KEY_CODE_TAB = 9;
export const EVENT_KEY_CODE_ESC = 27;
export const EVENT_KEY_CODE_ENTER = 13;
export const EVENT_KEY_CODE_SPACE = 32;
export const EVENT_KEY_CODE_COMMA = 188;
export const EVENT_KEY_CODE_ARROW_UP = 38;
export const EVENT_KEY_CODE_ARROW_DOWN = 40;
